import { useEffect } from 'react';
import { NewRequestBranch } from '../models/dashboard-models';
import { useGetBranchByIdInRequestView as fetchBranchByIdInRequestView } from './clients-hooks';

export const useFreshRequestBranch = (
    branchId: number | undefined,
    showModal: boolean,
    updateBranch: (branch: NewRequestBranch) => void,
) => {
    useEffect(() => {
        if (!showModal || !branchId) return;

        let active = true;
        fetchBranchByIdInRequestView(branchId).then((freshBranch) => {
            if (!active) return;
            updateBranch(freshBranch);
        }).catch((error) => {
            if (active) console.error('Failed to refresh selected branch', error);
        });

        return () => {
            active = false;
        };
    }, [branchId, showModal, updateBranch]);
};
